/*
 * constants
 */
import { AppPlatform } from "@emr/utils"
import { pgSchema } from "drizzle-orm/pg-core/schema"

export const schema = pgSchema(AppPlatform)
